import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "92%",
    width: "100%",
    border: "2px solid #6C65D9",
    borderRadius: "20px",
    padding: "16px",
    fontSize: "14px",
    [theme.breakpoints.down("lg")]: {
      height: "97%",
    },
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spaceBetween: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  tertiaryColor: {
    color: theme.palette.text.tertiary,
  },
  heading: {
    fontSize: "32px !important",
    [theme.breakpoints.down("lg")]: {
      fontSize: "26px !important",
    },
  },
  submitButton: {
    width: "max-content",
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    padding: "12px 100px",
  },
  versionName: {
    color: theme.palette.secondary.main,
    marginLeft: "50px",
  },
  dateAndPriority: {
    height: "33.3%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  date: {
    fontSize: "18px",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  fieldName: {
    fontSize: "14px",
    color: "#606479",
    textAlign: "center",
  },
  statusContainer: {
    height: "33.3%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  userAndDepartment: {
    height: "33.3%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

export default useStyles;
